export { default as Footer } from "./components/Main";
